// Generated by CoffeeScript 2.7.0
import "./application_init.js";
import $ from "jquery";

TryItParent.namespace('slideBar');

TryItParent.slideBar = function() {
  var body, menu, menuBtn, menuWidth;
  menu = $('#slide_menu');
  menuBtn = $('#menu, #close');
  body = $(document.body);
  menuWidth = menu.outerWidth();
  
  // #メニューボタンをクリックした時の動き
  return menuBtn.on('click', function() {
    body.toggleClass('open');
    if (body.hasClass('open')) {
      //open クラスが body についていたらメニューをスライドインする
      body.animate({
        'right': menuWidth
      }, 400);
      return menu.animate({
        'right': 0
      }, 400);
    } else {
      //open クラスが body についていなかったらスライドアウトする
      menu.animate({
        'right': -menuWidth
      }, 400);
      return body.animate({
        'right': 0
      }, 400);
    }
  });
};
